import GlobalMetaforaLogo from "./GlobalMetaforaLogo";

const LogoWithText = ({ size = "default", variant = "horizontal", className = "" }) => {
  const sizes = {
    small: { logo: 40, text: "text-lg", subtext: "text-xs" },
    default: { logo: 60, text: "text-2xl", subtext: "text-sm" },
    large: { logo: 100, text: "text-4xl", subtext: "text-lg" },
    hero: { logo: 150, text: "text-5xl", subtext: "text-xl" }
  };

  const s = sizes[size] || sizes.default;

  if (variant === "vertical") {
    return (
      <div className={`flex flex-col items-center gap-4 ${className}`}>
        <GlobalMetaforaLogo size={s.logo * 1.5} />
        <div className="text-center">
          <h1 className={`font-bold text-white tracking-wider ${s.text}`} style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            GLOBAL <span className="text-[#3b82f6]">METAFORA</span>
          </h1>
          <p className={`text-[#06b6d4] font-semibold tracking-[0.3em] ${s.subtext}`}>
            APP
          </p>
        </div>
      </div>
    );
  }

  // Horizontal (default)
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <GlobalMetaforaLogo size={s.logo} />
      <div>
        <h1 className={`font-bold text-white tracking-wider leading-tight ${s.text}`} style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          GLOBAL <span className="text-[#3b82f6]">METAFORA</span>
        </h1>
        <p className={`text-[#06b6d4] font-semibold tracking-[0.3em] ${s.subtext}`}>
          APP
        </p>
      </div>
    </div>
  );
};

// Logo simplificado solo icono para navbar
const LogoIcon = ({ size = 40, className = "" }) => {
  return (
    <div className={`relative ${className}`} style={{ width: size, height: size }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#60a5fa" />
            <stop offset="100%" stopColor="#3b82f6" />
          </linearGradient>
          <filter id="logoGlow">
            <feDropShadow dx="0" dy="0" stdDeviation="2" floodColor="#3b82f6" floodOpacity="0.5"/>
          </filter>
        </defs>
        
        {/* Hexágono de fondo */}
        <polygon
          points="50,5 90,27.5 90,72.5 50,95 10,72.5 10,27.5"
          fill="url(#logoGradient)"
          filter="url(#logoGlow)"
        />
        
        {/* G estilizada */}
        <path
          d="M60 35 
             C60 35 72 40 72 52 
             C72 65 62 75 50 75 
             C38 75 28 65 28 48 
             C28 32 40 22 55 22
             L55 30
             C44 30 36 38 36 48
             C36 60 44 68 50 68
             C58 68 65 62 65 52
             C65 46 62 42 55 42
             L55 50
             L48 50
             L48 35
             L60 35Z"
          fill="white"
        />
        
        {/* Flecha */}
        <path
          d="M48 50 L60 50 L60 44 L70 52 L60 60 L60 55 L48 55 Z"
          fill="#06b6d4"
        />
      </svg>
    </div>
  );
};

export { GlobalMetaforaLogo, LogoWithText, LogoIcon };
export default LogoWithText;
